/**
 * Removes the first n characters of a string
 * @param {string} string string of characters
 * @param {number} number number of characters to remove
 * @returns string
 */
const removeFirstNChars = (string: string, number: number): string => string.slice(-number);

export default removeFirstNChars;